import template from './form.html';
import hijoTemplate from './hijo.html';
import { FormActions } from 'core/services/form';
import familiasProductosI18N from 'i18n/familias-productos/es.json';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import { formatErrorMessage } from 'core/util';


export let FamiliaProductoFormComponent = {
  templateUrl: template,
  selector: 'familiaProductoForm',
  bindings: {
    view: '<',
    translations: '=',
    // objeto a usar como model del form
    dataForm: '=',
    afterSave: '&?',
    onCancel: '&?'
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(familiasProductosI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', '$scope', 'CustomModal', '$timeout', 'Filter'];

function FormController($state, $ngRedux, ngNotify, $stateParams, $scope, CustomModal, $timeout, Filter) {
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  let unsubscribe;

  this.localModel = {};
  const parametroFilter = Filter.path('codigo').eq('familias_productos_niveles');

  this.$onDestroy = () => {
    unsubscribe();
    $ngRedux.dispatch(rest.actions.familiasProducto.reset());
    $ngRedux.dispatch(rest.actions.parametros.reset());
    this.form();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid && !this.dataForm) {
      this.title = this.view ? this.translations['Ver familia de producto'] : this.translations['Editar familia de producto'];
      this.formEdit('familias-productos', $stateParams.uid);
    } else {
      this.title = this.translations['Nueva familia de producto'];
      this.form();
    }

    $ngRedux.dispatch(rest.actions.familiasProducto.reset());
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = this.dataForm ? this.dataForm : state.form.model;

    if (this.model.id && this.model.hijos) {
      this.data = this.model.hijos;
    } else {
      this.data = [];
    }

    if (!this.model.id) {
      this.model.ultimoNivel = false;
    }


    if (state.parametros.data && state.parametros.data.length === 1) {
      let parametro = state.parametros.data[0];
      let valor = parseInt(parametro.valor.value);
      if (parametro && valor) {
        this.localModel.niveles = valor;
      }
    }

    return {
      form: state.form
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de feedback en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.familias-productos.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');

      if (angular.isFunction(this.afterSave)) {
        this.afterSave();
      } else {
        $state.go('home.familias-productos.list');
      }
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    if (angular.isFunction(this.onCancel)) {
      this.onCancel();
    } else {
      $state.go('home.familias-productos.list');
    }
  }

  function doSubmit() {
    if ($scope.familiaProductoForm.$invalid) {
      this.submitted = true;
      return;
    }
    let data = Object.assign({}, this.model);
    this.save('familias-productos', data);
  }

  this.borrarItem = borrarItem.bind(this);
  this.editItem = editItem.bind(this);
  this.toggle = toggle.bind(this);
  this.moveLastToTheBeginning = moveLastToTheBeginning.bind(this);
  this.newSubItem = newSubItem.bind(this);
  this.firstSubItem = firstSubItem.bind(this);
  this.collapseAll = collapseAll.bind(this);
  this.expandAll = expandAll.bind(this);

  function borrarItem(scope) {
    var nodeData = scope.$modelValue;
    CustomModal.open({
      title: 'Eliminar Hijo',
      templateUrl: hijoTemplate,
      message: '¿Seguro que desea eliminar el ítem?',
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.delete({ id: nodeData.id }, {
          body: {}
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            scope.remove();
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  function toggle(scope) {
    scope.toggle();
  }

  function moveLastToTheBeginning() {
    var a = this.data.pop();
    this.data.splice(0, 0, a);
  }

  function newSubItem(scope) {
    var nodeData = scope.$modelValue;
    if (this.localModel.niveles && this.localModel.niveles < nodeData.nivel + 1) {
      ngNotify.set('Nivel maximo alcanzado', 'warn');
      return;
    }

    nodeData.hijos = nodeData.hijos || [];
    this.localModel.payload = {
      padre: nodeData,
      hijos: [],
      ultimoNivel: false
    };
    let self = this;
    CustomModal.open({
      title: 'Nuevo Hijo',
      templateUrl: hijoTemplate,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.post({}, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            data[0].nivel = nodeData.nivel + 1;
            nodeData.hijos.push(data[0]);
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  function firstSubItem() {
    this.localModel.payload = {
      padre: this.model,
      hijos: [],
      ultimoNivel: false
    };
    let self = this;
    CustomModal.open({
      title: 'Nuevo Hijo',
      templateUrl: hijoTemplate,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.post({}, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            data[0].nivel = 1;
            self.data.push(data[0]);
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }


  function editItem(scope) {
    var nodeData = scope.$modelValue;
    this.localModel.payload = nodeData;
    let self = this;
    CustomModal.open({
      title: 'Editar Hijo',
      templateUrl: hijoTemplate,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.familiasProducto.put({ id: nodeData.id }, {
          body: JSON.stringify(self.localModel.payload)
        }, (err, data) => {
          if (!err && data && data.length === 1) {
            nodeData = data[0];
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  function collapseAll() {
    $scope.$broadcast('angular-ui-tree:collapse-all');
  }

  function expandAll() {
    $scope.$broadcast('angular-ui-tree:expand-all');
  }

}


// WEBPACK FOOTER //
// ./src/components/familias-productos/form/form.component.js